export interface SortableItemVisibility {
  opacity: number;
  visibility: 'hidden' | 'visible';
  pointerEvents: 'auto' | 'none';
}

export function getSortableItemVisibility({
  isDragging,
  dragHidden,
}: {
  isDragging: boolean;
  dragHidden: boolean;
}): SortableItemVisibility {
  if (dragHidden) {
    return {
      opacity: 0,
      visibility: 'hidden',
      pointerEvents: 'none',
    };
  }

  if (isDragging) {
    return {
      opacity: 0.3,
      visibility: 'visible',
      pointerEvents: 'none',
    };
  }

  return {
    opacity: 1,
    visibility: 'visible',
    pointerEvents: 'auto',
  };
}

export function shouldHideSourceItemForFocusPreview({
  itemId,
  previewFocusedIds,
  committedFocusedIds,
}: {
  itemId: string;
  previewFocusedIds: Set<string>;
  committedFocusedIds: Set<string>;
}): boolean {
  return previewFocusedIds.has(itemId) && !committedFocusedIds.has(itemId);
}
